import { SelectOption } from '@kep-ui-kit/ui-components';

export const pageSizes: SelectOption[] = [
  { value: '10', text: '10' },
  { value: '50', text: '50' },
  { value: '100', text: '100' },
  { value: '500', text: '500' },
  { value: '1000', text: '1000' },
  { value: '5000', text: '5000' },
  { value: '10000', text: '10000' },
];
